import { faCircleXmark, faSearch, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import { Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import "./search.scss";
import { debounce, isEmpty, set } from "lodash";

import Modal from 'react-bootstrap/Modal';
import Search from "./search";

const SearchTW = (props) => { //selectedSearchItem

    const [searchValue, setSearchValue] = useState("");
    const [searchResult, setSearchResult] = useState([]);
    const [searchResultContainer, setSearchResultContainer] = useState(false);
    const [isEmptyResult, setIsEmptyResult] = useState(false);
    const searchResultsRef = useRef([]);
    const searchResultContainerRef = useRef(null);
    const searchResultRowsRef = useRef(null);
    const [visible, setVisible] = useState(false);
    const [visibleInput, setVisibleInput] = useState(false);
    const handleClose = () => setVisible(false);
    const [selectedResultIndex, setSelectedResultIndex] = useState(-1); // Seçili sonuç için yeni state

    useEffect(() => {
        if (searchResult.length > 0) {
            setSelectedResultIndex(0);
        } else {
            setSelectedResultIndex(-1);
        }
    }, [searchResult]);


    const handleKeyDown = useCallback(
        (event) => {
            let nextIndex;
            if (event.key === "ArrowDown") {
                if (selectedResultIndex >= searchResult.length - 1) {
                    nextIndex = 0;
                } else {
                    nextIndex = selectedResultIndex + 1;
                }
                setSelectedResultIndex(nextIndex);
                adjustScroll(nextIndex);
                event.preventDefault();
            } else if (event.key === "ArrowUp") {
                if (selectedResultIndex <= 0) {
                    nextIndex = searchResult.length - 1;
                } else {
                    nextIndex = selectedResultIndex - 1;
                }
                setSelectedResultIndex(nextIndex);
                adjustScroll(nextIndex);
                event.preventDefault();
            } else if (event.key === "Enter") {
                if (selectedResultIndex !== -1 && searchResult[selectedResultIndex]) {
                    // Seçili satır için `handleRowClick` fonksiyonunu çağır
                    handleRowClick(searchResult[selectedResultIndex]);
                    event.preventDefault(); // Form gönderimini önle
                }
            }
        }, [searchResult.length, selectedResultIndex]);

    const adjustScroll = (index) => {
        const currentItem = searchResultsRef.current[index];
        if (currentItem && searchResultContainerRef.current) {
            const container = searchResultContainerRef.current;
            const containerResultRows = searchResultRowsRef.current;
            const containerTop = container.scrollTop;
            const containerBottom = containerTop + container.clientHeight;
            const elementTop = currentItem.offsetTop;
            const elementBottom = elementTop + currentItem.clientHeight;

            if (elementBottom > containerBottom) {
                // Seçili öğe görünüm alanının altında kalıyorsa, öğeyi görünür yapmak için aşağı doğru scroll yap
                containerResultRows.scrollTop = elementBottom - container.clientHeight;
            } else if (elementTop < containerTop) {
                // Seçili öğe görünüm alanının üstünde kalıyorsa, öğeyi görünür yapmak için yukarı doğru scroll yap
                containerResultRows.scrollTop = elementTop;
            }
        }
    };

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [handleKeyDown]);

    // useEffect(() => {
    //   getPopularSearch();
    // }, []);

    // const getPopularSearch = () => {
    //   setSearchPopularResult(dummyPopularSearchArray);
    // };

    const fetchSearchResults = useCallback(
        debounce((query) => {
            if (!query) {
                setSearchResult([]);
                return;
            }
            console.log(query);

            setIsEmptyResult(false);

            // new Field("id", FieldType.String, true,false,true),
            // new Field("sourceId", FieldType.Int32, false),
            // new Field("dataId", FieldType.Int32, false),
            // new Field("objectId", FieldType.String, false),
            // new Field("uniqueCode", FieldType.String, false),
            // new Field("name", FieldType.String, false),
            // new Field("alternativeName", FieldType.String, false),
            // new Field("code", FieldType.String, false, true),
            // new Field("countryCode", FieldType.String, false, true, false),
            // new Field("visible", FieldType.Bool, false),
            // new Field("listed", FieldType.Bool, false),
            // new Field("elite", FieldType.Bool, false),
            // new Field("index", FieldType.Bool, false),
            // new Field("screenable", FieldType.Bool, false), bualnalarla sorgulayabilirsin

            const url = `https://api.rasyonet.com/service-hisselab-spotlight/collections/Hisselab.Symbols/documents/search?q=${query}&query_by=name,code&filter_by=visible:true&&listed:true&&class:Equity`;

            fetch(url, {
                method: "GET",
                headers: {
                    "x-typesense-api-key": "masterKeyk8pX5hD0793d8YQC5aD1aEPd7VleSuGP",
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log("fetchSearchResults:", data);
                    setSearchResultContainer(true);

                    if (data.hits == undefined || data.hits.length == 0) {
                        setSearchResult([]);
                        setIsEmptyResult(true);
                        return;
                    }
                    setSearchResult(data.hits);
                })
                .catch((error) => {
                    console.error("fetchSearchResults Error:", error);
                    document.getElementById("dataContainer").innerHTML =
                        "Bir hata oluştu: " + error;
                });
        }, 750),
        []
    );

    const handleChange = (event) => {
        const value = event.target.value;
        setSearchValue(value);
        // setSelectedResultIndex(-1);

        if (value.length >= 3) {
            console.log("Uzunluk 3.");
            fetchSearchResults(value);
        } else if (value.length === 0) {
            setSearchResultContainer(false);
        }
    };

    const handleFocus = () => {
        try {
            // setSearchResultContainer(true);
        } catch (error) {
            console.log(error);
        }
    };


    const handleBlur = () => {
        const timeout = setTimeout(() => {
            setSearchResultContainer(false);
        }, 300);
        // setBlurTimeout(timeout);
    };

    const handleRowClick = (item) => {
        // clearTimeout(blurTimeout);
        // console.log("Seçilen satır:", item);

        // dispatch(setSelectedSecurity(item.document));
        // setSearchResultContainer(false);

        // navigate(`/StockAnalysis/summary/${item.document.code}`);
        // setSearchValue("");
        
        handleClose();
        props.selectedSearchItem(item);
        setSearchValue("");
    };

    const resultItemClass = (index) =>
        `resault-wrap ${index === selectedResultIndex ? "hovered" : ""}`;

    const handleShow = (event) => {
            setVisible(true);
        
    }

    return (
        <div className="position-relative search-component">
            <div className="searchTW-div" onClick={(event) => handleShow(event)}>
                <FontAwesomeIcon icon={faSearch} />
                <span className="search-text">Sembol/Hisse Ara</span>
            </div>

            {searchResultContainer && (
                <Container
                    ref={searchResultContainerRef}
                    className="searchResultContainer position-absolute"
                >

                    <Row ref={searchResultRowsRef} className="searchResulRow">
                        {searchResult.length > 0 &&
                            searchResult.map((item, index) => (
                                <div
                                    ref={(el) => (searchResultsRef.current[index] = el)}
                                    key={item.objectId + index}
                                    className={resultItemClass(index)}
                                    onClick={() => handleRowClick(item)}>

                                    <div className="sec-detail">
                                        <div className="roboto-medium-14 ">
                                            {item.document.name}{" "}
                                        </div>
                                        <div className="roboto-regular-12 symbol-text">
                                            {item.document.code}{" "}
                                        </div>
                                    </div>
                                    <div className="sec-source">
                                        <div className="roboto-regular-12 source-text">
                                            Borsa Istanbul
                                        </div>
                                    </div>
                                </div>
                            ))}
                        {isEmptyResult && (
                            <div
                                style={{
                                    padding: 25,
                                    display: "flex",
                                    height: "100%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flex: 1,
                                }}
                            >
                                <div className="roboto-medium-14 " style={{}}>
                                    Sonuç Bulunamadı{" "}
                                </div>
                            </div>
                        )}
                    </Row>
                </Container>
            )}


            <Modal show={visible} onHide={handleClose}
                className='searchTWModal'
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header className='searchTWModalHeader'>
                    {/* <Modal.Title>Modal heading</Modal.Title> */}
                    <Container className='container'>
                        <Row className='columnsSelectHeaderRow cursor-pointer'>
                            <Col md="11" className='header-text roboto-regular-18 p-0'>Sembol/Hisse Ara</Col>
                            <Col md="1"><FontAwesomeIcon className='modalCloseIcon text-align-right float-right cursor-pointer p-0' icon={faXmark} onClick={handleClose} /></Col>
                        </Row>
                    </Container>
                </Modal.Header>

                <Modal.Body className='searchTWModalBody'>
                    <Search selectedSearchItem={handleRowClick} />
                </Modal.Body>
                {/* <Modal.Footer className='searchTWModalFooter'>

                </Modal.Footer> */}
            </Modal>
        </div>
    );
};

export default SearchTW;
